/**
 * 主路由 具体内容 有接口配置
 * 这里只进行页面注册
 */
export default [{
    path: '/manager-welcome',
    name: 'manager-welcome',
    component: () => import('@/views/manager/welcome.vue'),
    meta: {
      title: '欢迎页',
      affix: true, // 固定导航标签不可删除
      privilege: true, // 默认权限
    }
  }, {
    path: '/role',
    name: 'role',
    component: () => import('@/views/manager/role.vue'),
    meta: {
      title: '员工管理',
    }
  }, {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/manager/organization.vue'),
    meta: {
      title: '组织架构',
    }
  }, {
    path: '/role-list',
    name: 'role-list',
    component: () => import('@/views/manager/role-list.vue'),
    meta: {
      title: '角色管理',
    }
  }, {
    path: '/adminlog',
    name: 'adminlog',
    component: () => import('@/views/manager/adminlog.vue'),
    meta: {
      title: '操作日志',
    }
  }, {
    path: '/bank-account',
    name: 'bankAccount',
    component: () => import('@/views/manager/bank-account.vue'),
    meta: {
      title: '财务收支账户',
    }
  }, {
    path: '/cookbooks',
    name: 'cookbooks',
    component: () => import('@/views/manager/cookbooks.vue'),
    meta: {
      title: '营养菜谱',
    }
  }, {
    path: '/plat-locale',
    name: 'plat-locale',
    component: () => import('@/views/manager/plat-locale.vue'),
    meta: {
      title: '商城端多语言',
    }
  }, {
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/procurement/pricing.vue'),
    meta: {
      title: '商品定价',
      keepAlive: true,
    }
  }, {
    path: '/enquiry',
    name: 'enquiry',
    component: () => import('@/views/procurement/enquiry.vue'),
    meta: {
      title: '线上询价',
    }
  }, {
    path: '/enquiry-comparison',
    name: 'enquiry-comparison',
    component: () => import('@/views/procurement/enquiry-comparison.vue'),
    meta: {
      title: '比价',
      save: true
    }
  }, {
    path: '/pricing-audit',
    name: 'pricing-audit',
    component: () => import('@/views/procurement/pricing-audit.vue'),
    meta: {
      title: '定价审核'
    }
  }, {
    path: '/pricing-contractual',
    name: 'pricing-contractual',
    component: () => import('@/views/procurement/pricing-contractual.vue'),
    meta: {
      title: '客户报价'
    }
  }, {
    path: '/supplier-list',
    name: 'supplierlist',
    component: () => import('@/views/procurement/supplier-list.vue'),
    meta: {
      title: '供货商',
    }
  }, {
    path: '/procurement-addprice',
    name: 'procurement-addprice',
    component: () => import('@/views/procurement/add-price.vue'),
    meta: {
      title: '新增调价'
    }
  }, {
    path: '/procurement-supplier',
    name: 'procurement-supplier',
    component: () => import('@/views/procurement/supplier-manage.vue'),
    meta: {
      title: '供货商管理',
      keepAlive: true
    }
  }, {
    path: '/procurement-addsupplier',
    name: 'procurement-addsupplier',
    component: () => import('@/views/procurement/addsupplier.vue'),
    meta: {
      title: '新增供货商'
    }
  }, {
    path: '/procurement-task',
    name: 'procurement-task',
    component: () => import('@/views/procurement/procurement-task.vue'),
    meta: {
      title: '采购任务',
      keepAlive: true
    }
  }, {
    path: '/procurement-detail',
    name: 'procurement-detail',
    component: () => import('@/views/procurement/procurement-detail.vue'),
    meta: {
      title: '采购单详情',
    }
  }, {
    path: '/procurement',
    name: 'procurement',
    component: () => import('@/views/procurement/procurement.vue'),
    meta: {
      title: '采购单详情',
    }
  }, {
    path: '/client-list',
    name: 'clientList',
    component: () => import('@/views/procurement/client-list.vue'),
    meta: {
      title: '客户清单',
    }
  }, {
    path: '/order-list',
    name: 'order-list',
    component: () => import('@/views/business/order-list.vue'),
    meta: {
      title: '采购/供应清单',
      keepAlive: true
    }
  }, {
    path: '/help-order',
    name: 'help-order',
    component: () => import('@/views/business/help-order.vue'),
    meta: {
      title: '代客下单',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/business-addcustomer',
    name: 'business-addcustomer',
    component: () => import('@/views/business/addcustomer.vue'),
    meta: {
      title: '客户详情',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/business-visit',
    name: 'business-visit',
    component: () => import('@/views/business/visit.vue'),
    meta: {
      title: '客户拜访',
      keepAlive: true
    }
  }, {
    path: '/business-addvisit',
    name: 'business-addvisit',
    component: () => import('@/views/business/addvisit.vue'),
    meta: {
      title: '新拜访'
    }
  }, {
    path: '/business-adddspoint',
    name: 'business-adddspoint',
    component: () => import('@/views/business/add-dspoint.vue'),
    meta: {
      title: '配送范围详情'
    }
  }, {
    path: '/business-statedetail',
    name: 'business-statedetail',
    component: () => import('@/views/business/statedetail.vue'),
    meta: {
      title: '结算单详情'
    }
  }, {
    path: '/business-statedetailList',
    name: 'business-statedetailList',
    component: () => import('@/views/business/statedetailList.vue'),
    meta: {
      title: '结算单'
    }
  }, {
    path: '/business-collection',
    name: 'business-collection',
    component: () => import('@/views/business/collection.vue'),
    meta: {
      title: '发起收款',
      keepAlive: true
    }
  }, {
    path: '/after-sale',
    name: 'after-sale',
    component: () => import('@/views/business/after-sale.vue'),
    meta: {
      title: '商品售后处理'
    }
  }, {
    path: '/aftersale-print',
    name: 'aftersale-print-sale',
    component: () => import('@/views/templates/aftersale-print.vue'),
    meta: {
      title: '售后单打印设置'
    }
  }, {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/supply/finance.vue'),
    meta: {
      title: '采购报账申请',
      keepAlive: true
    }
  }, {
    path: '/add-oringin',
    name: 'addoringin',
    component: () => import('@/views/comprehensive/add-oringin.vue'),
    meta: {
      title: '产地溯源'
    }
  }, {
    path: '/commission',
    name: 'commission',
    component: () => import('@/views/comprehensive/commission.vue'),
    meta: {
      title: '提成方案'
    }
  }, {
    path: '/commission-proxy',
    name: 'commission-proxy',
    component: () => import('@/views/comprehensive/commission-proxy.vue'),
    meta: {
      title: '代采收费'
    }
  }, {
    path: '/addshop',
    name: 'addshop',
    component: () => import('@/views/supply/addshop.vue'),
    meta: {
      title: '添加商品',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/supplytask',
    name: 'supplytask',
    component: () => import('@/views/supply/supplytask.vue'),
    meta: {
      title: '供货任务',
      keepAlive: true
    }
  }, {
    path: '/supply-account',
    name: 'supplyAccount',
    component: () => import('@/views/supply/account.vue'),
    meta: {
      title: '账户',
    }
  }, {
    path: '/supply-margin-deposit',
    name: 'supplyMarginDeposit',
    component: () => import('@/views/supply/margin-deposit.vue'),
    meta: {
      title: '保证金',
    }
  }, {
    path: '/subcontract',
    name: 'subcontract',
    component: () => import('@/views/sorting/subcontract.vue'),
    meta: {
      title: '分包任务',
      keepAlive: true
    }
  }, {
    path: '/codelist',
    name: 'codelist',
    component: () => import('@/views/sorting/code-list.vue'),
    meta: {
      title: '标签码记录'
    }
  }, {
    path: '/sortingtask',
    name: 'sortingtask',
    component: () => import('@/views/sorting/sortingtask.vue'),
    meta: {
      title: '分拣任务',
      keepAlive: true
    }
  }, {
    path: '/sortingdetail',
    name: 'sortingdetail',
    component: () => import('@/views/sorting/sortingdetail.vue'),
    meta: {
      title: '分拣',
    }
  }, {
    path: '/subdetail',
    name: 'subdetail',
    component: () => import('@/views/sorting/sub-detail.vue'),
    meta: {
      title: '客户清单',
    }
  }, {
    path: '/address',
    name: 'address',
    component: () => import('@/views/delivery/address.vue'),
    meta: {
      title: '客户地图'
    }
  }, {
    path: '/address2',
    name: 'address2',
    component: () => import('@/views/delivery/address2.vue'),
    meta: {
      title: '送货路径'
    }
  }, {
    path: '/deliverymap',
    name: 'deliverymap',
    component: () => import('@/views/delivery/delivery-map.vue'),
    meta: {
      title: '配送排单'
    }
  }, {
    path: '/addroute',
    name: 'addroute',
    component: () => import('@/views/delivery/addroute.vue'),
    meta: {
      title: '添加路线'
    }
  }, {
    path: '/cityroute',
    name: 'cityroute',
    component: () => import('@/views/delivery/cityroute.vue'),
    meta: {
      title: '线路管理'
    }
  }, {
    path: '/transport',
    name: 'transport',
    component: () => import('@/views/delivery/transport.vue'),
    meta: {
      title: '商品装车单'
    }
  }, {
    path: '/printsetting',
    name: 'printsetting',
    component: () => import('@/views/templates/delivery-print.vue'),
    meta: {
      title: '送货单打印设置'
    }
  }, {
    path: '/deliverytask',
    name: 'deliverytask',
    component: () => import('@/views/delivery/deliverytask.vue'),
    meta: {
      title: '送货任务',
      keepAlive: true,
    }
  }, {
    path: '/receiving',
    name: 'receiving',
    component: () => import('@/views/delivery/receiving.vue'),
    meta: {
      title: '直送任务'
    }
  }, {
    path: '/dspointlist',
    name: 'dspointlist',
    component: () => import('@/views/delivery/dspointlist.vue'),
    meta: {
      title: '团长代收点',
      keepAlive: true
    }
  }, {
    path: '/dsgoodslist',
    name: 'dsgoodslist',
    component: () => import('@/views/delivery/dsgoodslist.vue'),
    meta: {
      title: '商品汇总',
    }
  }, {
    path: '/deliverydetail',
    name: 'deliverydetail',
    component: () => import('@/views/delivery/delivery-detail.vue'),
    meta: {
      title: '送货任务详情'
    }
  }, {
    path: '/checkedout',
    name: 'checkedout',
    component: () => import('@/views/delivery/checkedout.vue'),
    meta: {
      title: '送货任务出库',
    }
  }, {
    path: '/updatedelivery',
    name: 'updatedelivery',
    component: () => import('@/views/delivery/updatedelivery.vue'),
    meta: {
      title: '修改补录送货单',
      keepAlive: true
    }
  }, {
    path: '/update-delivery',
    name: 'update-delivery',
    component: () => import('@/views/delivery/update-delivery.vue'),
    meta: {
      title: '补录送货单修改',
    }
  }, {
    path: '/deliveryback',
    name: 'deliveryback',
    component: () => import('@/views/delivery/back.vue'),
    meta: {
      title: '取件回库任务'
    }
  }, {
    path: '/feeSetting',
    name: 'feeSetting',
    component: () => import('@/views/delivery/fee-setting.vue'),
    meta: {
      title: '配送运费'
    }
  }, {
    path: '/initiate',
    name: 'initiate',
    component: () => import('@/views/finance/initiate.vue'),
    meta: {
      title: '订单结算',
      keepAlive: true
    }
  }, {
    path: '/apply-withdraw',
    name: 'apply-withdraw',
    component: () => import('@/views/finance/apply-withdraw.vue'),
    meta: {
      title: '提现申请',
      keepAlive: true
    }
  }, {
    path: '/plat-withdraw',
    name: 'plat-withdraw',
    component: () => import('@/views/finance/plat-withdraw.vue'),
    meta: {
      title: '账户提现',
      keepAlive: true
    }
  }, {
    path: '/running',
    name: 'running',
    component: () => import('@/views/finance/running.vue'),
    meta: {
      title: '财务流水'
    }
  }, {
    path: '/comprehensive-setting',
    name: 'comprehensive-setting',
    component: () => import('@/views/comprehensive/setting.vue'),
    meta: {
      title: '基本设置'
    }
  }, {
    path: '/comprehensive-help',
    name: 'comprehensive-help',
    component: () => import('@/views/comprehensive/help.vue'),
    meta: {
      title: '使用帮助'
    }
  }, {
    path: '/comprehensive-helpdetail',
    name: 'comprehensive-helpdetail',
    component: () => import('@/views/comprehensive/helpdetail.vue'),
    meta: {
      title: '帮助详情'
    }
  }, {
    path: '/comprehensive-agreement',
    name: 'comprehensive-agreement',
    component: () => import('@/views/comprehensive/agreement.vue'),
    meta: {
      title: '项目协议'
    }
  }, {
    path: '/comprehensive-adverpic',
    name: 'comprehensive-adverpic',
    component: () => import('@/views/comprehensive/adverpic.vue'),
    meta: {
      title: '广告图'
    }
  }, {
    path: '/comprehensive-addadverpic',
    name: 'comprehensive-addadverpic',
    component: () => import('@/views/comprehensive/addadverpic.vue'),
    meta: {
      title: '添加广告图'
    }
  }, {
    path: '/comprehensive-notice',
    name: 'comprehensive-notice',
    component: () => import('@/views/comprehensive/notice.vue'),
    meta: {
      title: '公告头条'
    }
  }, {
    path: '/comprehensive-addnotice',
    name: 'comprehensive-addnotice',
    component: () => import('@/views/comprehensive/addnotice.vue'),
    meta: {
      title: '添加公告'
    }
  }, {
    path: '/comprehensive-customer',
    name: 'comprehensive-customer',
    component: () => import('@/views/comprehensive/customer.vue'),
    meta: {
      title: '客户列表',
      keepAlive: true
    }
  }, {
    path: '/agree-order',
    name: 'agree-order',
    component: () => import('@/views/comprehensive/agree-order.vue'),
    meta: {
      title: '协议报价单',
    }
  }, {
    path: '/show-good',
    name: 'show-good',
    component: () => import('@/views/comprehensive/show-good.vue'),
    meta: {
      title: '商品显示单',
    }
  }, {
    path: '/manager-performance',
    name: 'manager-performance',
    component: () => import('@/views/statistics/performance.vue'),
    meta: {
      title: '人员绩效',
      keepAlive: true
    }
  }, {
    path: '/comprehensive-unusual',
    name: 'comprehensive-unusual',
    component: () => import('@/views/comprehensive/unusual.vue'),
    meta: {
      title: '异常通知',
      keepAlive: true
    }
  }, {
    path: '/backmoney',
    name: 'backmoney',
    component: () => import('@/views/comprehensive/backmoney.vue'),
    meta: {
      title: '退款详情'
    }
  }, {
    path: '/comprehensive-addperson',
    name: 'comprehensive-addperson',
    component: () => import('@/views/comprehensive/addperson.vue'),
    meta: {
      title: '添加人员',
    }
  }, {
    path: '/comprehensive-goods',
    name: 'comprehensive-goods',
    component: () => import('@/views/comprehensive/goods.vue'),
    meta: {
      title: '商品管理',
      keepAlive: true
    }
  }, {
    path: '/comprehensive-goodstype',
    name: 'comprehensive-goodstype',
    component: () => import('@/views/comprehensive/goodstype.vue'),
    meta: {
      title: '商品分类'
    }
  }, {
    path: '/comprehensive-promotion',
    name: 'comprehensive-promotion',
    component: () => import('@/views/comprehensive/promotion.vue'),
    meta: {
      title: '主题活动'
    }
  }, {
    path: '/comprehensive-promotiondetail',
    name: 'comprehensive-promotiondetail',
    component: () => import('@/views/comprehensive/promotiondetail.vue'),
    meta: {
      title: '活动详情'
    }
  }, {
    path: '/comprehensive-order',
    name: 'comprehensive-order',
    component: () => import('@/views/comprehensive/order.vue'),
    meta: {
      title: '订单列表',
      keepAlive: true
    }
  }, {
    path: '/comprehensive-orderdetail',
    name: 'comprehensive-orderdetail',
    component: () => import('@/views/comprehensive/orderdetail.vue'),
    meta: {
      title: '订单详情',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/comprehensive-question',
    name: 'comprehensive-question',
    component: () => import('@/views/comprehensive/question.vue'),
    meta: {
      title: '需求反馈'
    }
  }, {
    path: '/sub-account',
    name: 'sub-account',
    component: () => import('@/views/comprehensive/sub-account.vue'),
    meta: {
      title: '子账号'
    }
  }, {
    path: '/comprehensive-sub-department',
    name: 'comprehensive-sub-department',
    component: () => import('@/views/comprehensive/sub-department.vue'),
    meta: {
      title: '子部门管理',
    }
  }, {
    path: '/storelist',
    name: 'storelist',
    component: () => import('@/views/store/store-list.vue'),
    meta: {
      title: '库房信息'
    }
  }, {
    path: '/storedetail',
    name: 'storedetail',
    component: () => import('@/views/store/store-detail.vue'),
    meta: {
      title: '仓库详情'
    }
  }, {
    path: '/audit',
    name: 'audit',
    component: () => import('@/views/store/audit.vue'),
    meta: {
      title: '商品入库审核'
    }
  }, {
    path: '/inventory',
    name: 'inventory',
    component: () => import('@/views/store/inventory.vue'),
    meta: {
      title: '库存商品',
      keepAlive: true
    }
  }, {
    path: '/checkin',
    name: 'checkin',
    component: () => import('@/views/store/checkin.vue'),
    meta: {
      title: '入库',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/views/store/checkout.vue'),
    meta: {
      title: '出库',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/checklogs',
    name: 'checklogs',
    component: () => import('@/views/store/check-logs.vue'),
    meta: {
      title: '出入库日志'
    }
  }, {
    path: '/goods-batch',
    name: 'goodsBatch',
    component: () => import('@/views/store/goods-batch.vue'),
    meta: {
      title: '商品批次'
    }
  }, {
    path: '/traceability',
    name: 'traceability',
    component: () => import('@/views/store/traceability.vue'),
    meta: {
      title: '产地溯源',
      keepAlive: true
    }
  }, {
    path: '/residues',
    name: 'residues',
    component: () => import('@/views/store/residues.vue'),
    meta: {
      title: '商品检测'
    }
  }, {
    path: '/residues-detail',
    name: 'residuesDetail',
    component: () => import('@/views/store/residues-detail.vue'),
    meta: {
      title: '商品检测详情'
    }
  }, {
    path: '/report-print',
    name: 'report-print',
    component: () => import('@/views/templates/report-print.vue'),
    meta: {
      title: '农残报告模板'
    }
  }, {
    path: '/checkresult',
    name: 'checkresult',
    component: () => import('@/views/store/check-result.vue'),
    meta: {
      title: '盘点记录'
    }
  }, {
    path: '/inventorysave',
    name: 'inventorysave',
    component: () => import('@/views/store/inventory-save.vue'),
    meta: {
      title: '盘点',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/takedelivery',
    name: 'takedelivery',
    component: () => import('@/views/store/take-delivery.vue'),
    meta: {
      title: '收货入库',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, //不能做缓存 如果需要缓存需要设置vuex中datas请求时间限制
  {
    path: '/goodsstatistics',
    name: 'goodsstatistics',
    component: () => import('@/views/statistics/goods-statistics.vue'),
    meta: {
      title: '出入库商品'
    }
  }, {
    path: '/commodity-circulation',
    name: 'commodity-circulation',
    component: () => import('@/views/statistics/commodity-circulation.vue'),
    meta: {
      title: '商品流通'
    }
  }, {
    path: '/goodsprofit',
    name: 'goodsprofit',
    component: () => import('@/views/statistics/goods-profit.vue'),
    meta: {
      title: '下单商品统计'
    }
  }, {
    path: '/goodsoldstatistics',
    name: 'goodsoldstatistics',
    component: () => import('@/views/statistics/goods-old-statistics.vue'),
    meta: {
      title: '分割商品利润'
    }
  }, {
    path: '/orderstatistics',
    name: 'orderstatistics',
    component: () => import('@/views/statistics/order-statistics.vue'),
    meta: {
      title: '订单利润统计'
    }
  }, {
    path: '/businessStatistics',
    name: 'businessStatistics',
    component: () => import('@/views/statistics/business-statistics.vue'),
    meta: {
      title: '业务统计'
    }
  }, {
    path: '/goodsStatistics2',
    name: 'goodsStatistics2',
    component: () => import('@/views/statistics/goods-statistics2.vue'),
    meta: {
      title: '商品销售'
    }
  }, {
    path: '/purchaseStatistics',
    name: 'purchaseStatistics',
    component: () => import('@/views/statistics/purchase-statistics.vue'),
    meta: {
      title: '采购统计'
    }
  }, {
    path: '/productStatistics',
    name: 'productStatistics',
    component: () => import('@/views/statistics/product-statistics.vue'),
    meta: {
      title: '分拣成品统计'
    }
  }, {
    path: '/goodsSaleStatistics',
    name: 'goodsSaleStatistics',
    component: () => import('@/views/statistics/goods-sale-statistics.vue'),
    meta: {
      title: '商品售价趋势'
    }
  }, {
    path: '/todayStatis',
    name: 'todayStatis',
    component: () => import('@/views/statistics/today-statis.vue'),
    meta: {
      title: '今日经营'
    }
  }, {
    path: '/everydaycount',
    name: 'everydaycount',
    component: () => import('@/views/statistics/every-day-count.vue'),
    meta: {
      title: '每日经营概况'
    }
  }, {
    path: '/paymentStatistics',
    name: 'paymentStatistics',
    component: () => import('@/views/statistics/payment-statistics.vue'),
    meta: {
      title: '订单收款'
    }
  }, {
    path: '/payStatistics',
    name: 'payStatistics',
    component: () => import('@/views/statistics/pay-statistics.vue'),
    meta: {
      title: '付款统计'
    }
  }, {
    path: '/statistics-loss',
    name: 'statistics-loss',
    component: () => import('@/views/statistics/loss.vue'),
    meta: {
      title: '损耗统计'
    }
  }, {
    path: '/marketing-applets',
    name: 'marketing-applets',
    component: () => import('@/views/marketing/applets.vue'),
    meta: {
      title: '第三方配置'
    }
  }, {
    path: '/marketing-settingIndex',
    name: 'marketing-settingIndex',
    component: () => import('@/views/marketing/setting-index.vue'),
    meta: {
      title: '自定义首页'
    }
  }, {
    path: '/brand-welcome',
    name: 'brand-welcome',
    component: () => import('@/views/brand/welcome.vue'),
    meta: {
      title: '欢迎页'
    }
  }, {
    path: '/brand-staffMember',
    name: 'brand-staffMember',
    component: () => import('@/views/brand/staff-member.vue'),
    meta: {
      title: '工作人员'
    }
  }, {
    path: '/brand-businessStatistics',
    name: 'brand-businessStatistics',
    component: () => import('@/views/brand/business-statistics.vue'),
    meta: {
      title: '业务统计'
    }
  }, {
    path: '/brand-goodsStatistics',
    name: 'brand-goodsStatistics',
    component: () => import('@/views/brand/goods-statistics.vue'),
    meta: {
      title: '商品统计'
    }
  }, {
    path: '/brand-purchaseStatistics',
    name: 'brand-purchaseStatistics',
    component: () => import('@/views/brand/purchase-statistics.vue'),
    meta: {
      title: '采购统计'
    }
  }, {
    path: '/brand-commodityProfit',
    name: 'brand-commodityProfit',
    component: () => import('@/views/brand/commodity-profit.vue'),
    meta: {
      title: '商品利润'
    }
  }, {
    path: '/brand-orderProfit',
    name: 'brand-orderProfit',
    component: () => import('@/views/brand/order-profit.vue'),
    meta: {
      title: '订单利润'
    }
  }, {
    path: '/brand-financialCollection',
    name: 'brand-financialCollection',
    component: () => import('@/views/brand/financial-collection.vue'),
    meta: {
      title: '财务收款'
    }
  }, {
    path: '/formulate-purchase',
    name: 'formulate-purchase',
    component: () => import('@/views/procurement/formulate-purchase.vue'),
    meta: {
      title: '制定采购',
    }
  }, {
    path: '/sorting-out',
    name: 'sorting-out',
    component: () => import('@/views/sorting/sorting-out.vue'),
    meta: {
      title: '分拣缺货',
      keepAlive: true
    }
  }, {
    path: '/replenishment',
    name: 'replenishment',
    component: () => import('@/views/procurement/replenishment.vue'),
    meta: {
      title: '预采补采任务',
      keepAlive: true,
    }
  }, {
    path: '/procurement-audit',
    name: 'procurementAudit',
    component: () => import('@/views/procurement/audit.vue'),
    meta: {
      title: '采购超价审核'
    }
  }, {
    path: '/parent-task',
    name: 'parent-task',
    component: () => import('@/views/procurement/parent-task.vue'),
    meta: {
      title: '集采任务'
    }
  }, {
    path: '/parent-bill',
    name: 'parent-bill',
    component: () => import('@/views/procurement/parent-bill.vue'),
    meta: {
      title: '集采报单'
    }
  }, {
    path: '/integral-flow',
    name: 'integral-flow',
    component: () => import('@/views/finance/integral-flow.vue'),
    meta: {
      title: '积分流水'
    }
  }, {
    path: '/cloud-goods',
    name: 'cloud-goods',
    component: () => import('@/views/comprehensive/cloud-goods.vue'),
    meta: {
      title: '云商品库'
    }
  }, {
    path: '/parent-goods',
    name: 'parent-goods',
    component: () => import('@/views/comprehensive/parent-goods.vue'),
    meta: {
      title: '集采商品库'
    }
  }, {
    path: '/basket',
    name: 'basket',
    component: () => import('@/views/delivery/basket.vue'),
    meta: {
      title: '篮筐商品'
    }
  }, {
    path: '/returnOrder',
    name: 'returnOrder',
    component: () => import('@/views/comprehensive/return-order.vue'),
    meta: {
      title: '退货订单'
    }
  }, {
    path: '/order-print',
    name: 'order-print',
    component: () => import('@/views/templates/order-print.vue'),
    meta: {
      title: '订单打印设置'
    }
  }, {
    path: '/process-management',
    name: 'process-management',
    component: () => import('@/views/comprehensive/process-management.vue'),
    meta: {
      title: '加工工艺管理'
    }
  }, {
    path: '/goods-barcode',
    name: 'goods-barcode',
    component: () => import('@/views/comprehensive/goods-barcode.vue'),
    meta: {
      title: '商品条码库'
    }
  }, {
    path: '/order-goods',
    name: 'order-goods',
    component: () => import('@/views/comprehensive/order-goods.vue'),
    meta: {
      title: '订单商品'
    }
  }, {
    path: '/processing-task',
    name: 'processing-task',
    component: () => import('@/views/sorting/processing-task.vue'),
    meta: {
      title: '加工任务列表'
    }
  }, {
    path: '/turnover-basket',
    name: 'turnover-basket',
    component: () => import('@/views/sorting/turnover-basket.vue'),
    meta: {
      title: '周转筐管理'
    }
  }, {
    path: '/basket-management',
    name: 'basket-management',
    component: () => import('@/views/sorting/basket-management.vue'),
    meta: {
      title: '周转筐v2'
    }
  }, {
    path: '/setting-label',
    name: 'setting-label',
    component: () => import('@/views/sorting/setting-label'),
    meta: {
      title: '标签模板'
    }
  }, {
    path: '/reimbursement-supply',
    name: 'reimbursement-supply',
    component: () => import('@/views/procurement/reimbursement-supply.vue'),
    meta: {
      title: '供应报账申请',
      keepAlive: true
    }
  }, {
    path: '/designated-supplier',
    name: 'designated-supplier',
    component: () => import('@/views/procurement/designated-supplier.vue'),
    meta: {
      title: '指定供货'
    }
  }, {
    path: '/cate-discount',
    name: 'cate-discount',
    component: () => import('@/views/marketing/cate-discount.vue'),
    meta: {
      title: '分类折扣'
    }
  }, {
    path: '/supply-settlement',
    name: 'supply-settlement',
    component: () => import('@/views/finance/supply-settlement.vue'),
    meta: {
      title: '供应对账结算'
    }
  }, {
    path: '/coupon',
    name: 'coupon',
    component: () => import('@/views/marketing/coupon.vue'),
    meta: {
      title: '优惠券'
    }
  }, {
    path: '/special-prices',
    name: 'special-prices',
    component: () => import('@/views/marketing/special-prices.vue'),
    meta: {
      title: '特价活动',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/marketing-promotion',
    name: 'marketing-promotion',
    component: () => import('@/views/marketing/promotion.vue'),
    meta: {
      title: '主题活动二'
    }
  }, {
    path: '/marketing-supplier',
    name: 'marketing-supplier',
    component: () => import('@/views/marketing/supplier.vue'),
    meta: {
      title: '供应商店推荐'
    }
  }, {
    path: '/sales-promotion',
    name: 'sales-promotion',
    component: () => import('@/views/marketing/sales-promotion.vue'),
    meta: {
      title: '满减/积分'
    }
  }, {
    path: '/marketing-vip',
    name: 'marketing-vip',
    component: () => import('@/views/marketing/vip.vue'),
    meta: {
      title: '付费会员制'
    }
  }, {
    path: '/recharge',
    name: 'recharge',
    component: () => import('@/views/marketing/recharge.vue'),
    meta: {
      title: '充值赠送'
    }
  }, {
    path: '/statements',
    name: 'statements',
    component: () => import('@/views/finance/statements.vue'),
    meta: {
      title: '采购供货对账单',
      keepAlive: true
    }
  }, {
    path: '/statements-detail',
    name: 'statements-detail',
    component: () => import('@/views/finance/statements-detail.vue'),
    meta: {
      title: '对账单详情',
    }
  }, {
    path: '/finance-commission',
    name: 'financeCommission',
    component: () => import('@/views/finance/commission.vue'),
    meta: {
      title: '业务提成'
    }
  }, {
    path: '/invoice',
    name: 'invoice',
    component: () => import('@/views/finance/invoice.vue'),
    meta: {
      title: '开发票申请'
    }
  }, {
    path: '/inout-bill',
    name: 'inout-bill',
    component: () => import('@/views/finance/inout-bill.vue'),
    meta: {
      title: '收支单据'
    }
  }, {
    path: '/inout-cate',
    name: 'inout-cate',
    component: () => import('@/views/finance/inout-cate.vue'),
    meta: {
      title: '收支单据'
    }
  },

  {
    path: '/checkindata',
    name: 'checkindata',
    component: () => import('@/views/store/checkin-data.vue'),
    meta: {
      title: '入库单据表',
      keepAlive: true
    }
  }, {
    path: '/checkout-table',
    name: 'checkout-table',
    component: () => import('@/views/store/checkout-table.vue'),
    meta: {
      title: '出库送货单'
    }
  }, {
    path: '/warehouse-change',
    name: 'warehouse-change',
    component: () => import('@/views/store/warehouse-change.vue'),
    meta: {
      title: '采购入库单',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/inventory-conversion',
    name: 'inventory-conversion',
    component: () => import('@/views/store/inventory-conversion.vue'),
    meta: {
      title: '转换详情',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/inventory-conversion-list',
    name: 'inventory-conversion-list',
    component: () => import('@/views/store/inventory-conversion-list.vue'),
    meta: {
      title: '库存转换'
    }
  }, {
    path: '/warehouse-receipt-print',
    name: 'warehouse-receipt-print',
    component: () => import('@/views/templates/checkin-print.vue'),
    meta: {
      title: '入库单据打印设置'
    }
  }, {
    path: '/edit-bill',
    name: 'edit-bill',
    component: () => import('@/views/finance/edit-bill.vue'),
    meta: {
      title: '对账单',
      keepAlive: true,
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/bill-list',
    name: 'bill-list',
    component: () => import('@/views/finance/bill-list.vue'),
    meta: {
      title: '报账单', //应付入库报账表 应付退货入库报账表 应收出库报账表 应付供应商报账表
    }
  }, {
    path: '/gross-margin',
    name: 'gross-margin',
    component: () => import('@/views/statistics/gross-margin.vue'),
    meta: {
      title: '销售毛利表'
    }
  }, {
    path: '/processingStatistics',
    name: 'processingStatistics',
    component: () => import('@/views/statistics/processing-statistics.vue'),
    meta: {
      title: '加工包装统计'
    }
  }, {
    path: '/dataAnalysis',
    name: 'dataAnalysis',
    component: () => import('@/views/statistics/data-analysis.vue'),
    meta: {
      title: '客情分析'
    }
  }, {
    path: '/inoutStatustics',
    name: 'inoutStatustics',
    component: () => import('@/views/statistics/inout-statustics.vue'),
    meta: {
      title: '收支报表'
    }
  }, {
    path: '/inoutStatustics-account',
    name: 'inoutStatustics-account',
    component: () => import('@/views/statistics/inout-statustics-account.vue'),
    meta: {
      title: '账户报表'
    }
  }, {
    path: '/afterSaleStatistics',
    name: 'afterSaleStatistics',
    component: () => import('@/views/statistics/after-sale-statistics.vue'),
    meta: {
      title: '售后统计'
    }
  }, {
    path: '/replenishmentStatistics',
    name: 'replenishmentStatistics',
    component: () => import('@/views/statistics/replenishment-statistics.vue'),
    meta: {
      title: '补货统计'
    }
  }, {
    path: '/goods-summary',
    name: 'goods-summary',
    component: () => import('@/views/statistics/goods-summary.vue'),
    meta: {
      title: '商品汇总'
    }
  }, {
    path: '/goods-record',
    name: 'goods-record',
    component: () => import('@/views/statistics/goods-record.vue'),
    meta: {
      title: '商品浏览'
    }
  }, {
    path: '/visit',
    name: 'visit',
    component: () => import('@/views/statistics/visit.vue'),
    meta: {
      title: '客户拜访'
    }
  },

  {
    path: '/periodic-bill-supplier',
    name: 'periodic-bill-supplier',
    component: () => import('@/views/finance/periodic-bill-supplier.vue'),
    meta: {
      title: '供应商周期结算'
    }
  }, {
    path: '/periodic-bill',
    name: 'periodic-bill',
    component: () => import('@/views/finance/periodic-bill.vue'),
    meta: {
      title: '客户周期结算'
    }
  }, {
    path: '/receivable',
    name: 'receivable',
    component: () => import('@/views/finance/receivable.vue'),
    meta: {
      title: '结算对账单',
      keepAlive: true
    }
  }, {
    path: '/basket-bill',
    name: 'basket-bill',
    component: () => import('@/views/finance/basket-bill.vue'),
    meta: {
      title: '周转筐报账表'
    }
  }, {
    path: '/sales-bill',
    name: 'sales-bill',
    component: () => import('@/views/finance/sales-bill.vue'),
    meta: {
      title: '销售扣点报账'
    }
  }, {
    path: '/sales-settlement',
    name: 'sales-settlement',
    component: () => import('@/views/finance/sales-settlement.vue'),
    meta: {
      title: '销售扣点结算'
    }
  }, {
    path: '/sales-settlement-detail',
    name: 'sales-settlement-detail',
    component: () => import('@/views/finance/sales-settlement-detail.vue'),
    meta: {
      title: '对账单详情'
    }
  },

  // 寄售
  {
    path: '/consignment-goods',
    name: 'consignment-goods',
    component: () => import('@/views/consignment/goods.vue'),
    meta: {
      title: '寄售商品库'
    }
  }, {
    path: '/consignment-log',
    name: 'consignment-log',
    component: () => import('@/views/consignment/log.vue'),
    meta: {
      title: '寄售商品日志'
    }
  }, {
    path: '/consignment-create-checkout',
    name: 'consignment-create-checkout',
    component: () => import('@/views/consignment/create-checkout.vue'),
    meta: {
      title: '寄售销售出库',
      save: true, // 离开页面未保存判定
    }
  }, {
    path: '/consignment-settlement',
    name: 'consignment-settlement',
    component: () => import('@/views/consignment/settlement.vue'),
    meta: {
      title: '寄售结算列表'
    }
  }, {
    path: '/consignment-statements',
    name: 'consignment-statements',
    component: () => import('@/views/consignment/statements.vue'),
    meta: {
      title: '应收寄售报账表'
    }
  }, {
    path: '/consignment-profit',
    name: 'consignment-profit',
    component: () => import('@/views/consignment/profit.vue'),
    meta: {
      title: '寄售商品利润'
    }
  }, {
    path: '/consignment-sales',
    name: 'consignment-sales',
    component: () => import('@/views/consignment/sales.vue'),
    meta: {
      title: '寄售销售表'
    }
  },

  {
    path: '/setting-shop',
    name: 'setting-shop',
    component: () => import('@/views/setting/shop.vue'),
    meta: {
      title: '自定义商城'
    }
  },
  {
    path: '/device-list',
    name: 'device-list',
    component: () => import('@/views/device/device-list.vue'),
    meta: {
      title: '硬件管理'
    }
  },
  {
    path: '/device-map',
    name: 'device-map',
    component: () => import('@/views/device/device-map.vue'),
    meta: {
      title: '车载监控',
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/main.js